import React from "react";

const CompHomo = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Rota /comp-homo funcionando ✅</h1>
    </div>
  );
};

export default CompHomo;
